import { Icon, type TIconProps } from '~/components/icon'
import type { TCardCategoryOrientation } from '../../types'

interface CardCategoryIconProps extends TIconProps {
  disabled?: boolean
  orientation?: TCardCategoryOrientation
  pressed?: boolean
}

export function CardCategoryIcon({
  disabled = false,
  orientation = 'horizontal',
  symbol = 'rdicon-default',
  testID,
  pressed = false,
}: CardCategoryIconProps) {
  const renderIconColor = () => {
    if (disabled) {
      return 'colorTextNeutralDisabled'
    }
    if (pressed) {
      return 'colorActionTextOnbrandPressed'
    }
    return 'colorActionTextOnbrandDefault'
  }

  const renderIconSize = () => {
    if (orientation === 'horizontal') {
      return 'small'
    }
    return 'medium'
  }

  return (
    <Icon
      size={renderIconSize()}
      testID={testID}
      symbol={symbol}
      color={renderIconColor()}
    />
  )
}
